import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { at } from "lodash";
import { useField } from "formik";

const CheckboxField = (props) => {
  const {  name, label, width, required, isDisabled, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const [error] = at(meta, "error", "touched");
  const { value } = field;
  const { setValue } = helper;

  const renderHelperText = () => {
    if ( error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  };

  function onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl {...rest} style={{width: width || '100%'}}>
      <FormControlLabel
        value={value}
        checked={value}
        required={required}
        control={<Checkbox onChange={onChange} disabled={isDisabled}/>}
        label={label}
      />
      {renderHelperText()}
    </FormControl>
  );
};
export default React.memo(CheckboxField);
